// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixedbanner[data-v-6d9b3d95]{position:fixed;bottom:0;left:0;height:89px;width:100%;background-color:hsla(0,0%,100%,.95)}.taller[data-v-6d9b3d95]{height:89px}", ""]);
// Exports
module.exports = exports;
